// extracted by mini-css-extract-plugin
module.exports = {"powered-by":"PD_93qcU3m_pkqwmOUOAe"};